export const Key = {
    sessionToken:"sessionToken",
    tempSessionToken:"tempSessionToken",
    roomData:"roomData",
    test:"test",
    production:"production",
    development:"development",
    chatboxvisible:"chatboxvisible",
    cameraon:"cameraon",
    micon:"micon",
    theme:"theme",
    light:"light",
    dark:"dark"
}